export interface Resource {
  id: string;
  title: string;
  description: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  tags: string[];
  downloadCount: number;
  rating: number;
  date: string;
  content: string;
  featured: boolean;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const siteInfo = {
  name: '给力资源库',
  tagline: '海量优质资源一站式获取平台',
  description: '给力资源库汇聚海量精品资源，涵盖学习、办公、设计、工具等多类别资源，免费下载、持续更新。无论你是学生、职场人还是创作者，给力资源库都能满足你的资源需求，让你的工作与学习效率倍增。',
  keywords: '给力资源库,给力资源库免费下载,给力资源库精品合集,优质资源一站式平台,学习资源库大全,办公资源免费获取,设计素材资源库,工具软件资源合集',
  url: 'https://geiliziyuan.com',
  email: 'contact@geiliziyuan.com',
  wechat: 'GeiliZiyuan',
  founded: '2020',
  stats: {
    resources: '50,000+',
    users: '1,200,000+',
    downloads: '8,600,000+',
    updates: '每日更新',
  },
};

export const categories: Category[] = [
  { name: '学习资源', slug: 'study', description: '考试资料、课程笔记、学术论文、电子书等优质学习资源合集', icon: 'ri-book-open-line', count: 12480 },
  { name: '办公资源', slug: 'office', description: 'PPT模板、Word文档、Excel表格、工作报告等高效办公资源', icon: 'ri-briefcase-line', count: 8960 },
  { name: '设计素材', slug: 'design', description: 'UI套件、图标包、字体、样机、插画等设计师必备素材', icon: 'ri-palette-line', count: 15320 },
  { name: '工具软件', slug: 'tools', description: '效率工具、实用插件、开发资源、系统工具等精品软件合集', icon: 'ri-tools-line', count: 6720 },
  { name: '视频素材', slug: 'video', description: '视频模板、AE特效、转场动画、音效素材等视频创作资源', icon: 'ri-film-line', count: 9340 },
  { name: '源码资源', slug: 'code', description: '网站源码、小程序源码、前端模板、后端框架等开发资源', icon: 'ri-code-box-line', count: 5180 },
];

export const resources: Resource[] = [
  {
    id: 'r001',
    title: '2025年公务员考试全套备考资料包',
    description: '包含行测、申论、面试全阶段备考资料，真题解析+模拟试卷+答题技巧，助你高效备考。',
    category: '学习资源',
    categorySlug: 'study',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20exam%20preparation%20study%20materials%20with%20books%20and%20laptop%20on%20clean%20desk%2C%20warm%20natural%20lighting%2C%20minimal%20aesthetic%2C%20soft%20cream%20background%2C%20educational%20theme%2C%20high%20detail%20editorial%20photography%20with%20organized%20composition&width=800&height=600&seq=resource-study-01&orientation=landscape',
    tags: ['公务员', '考试资料', '行测', '申论'],
    downloadCount: 48920,
    rating: 4.8,
    date: '2026-07-28',
    content: '',
    featured: true,
  },
  {
    id: 'r002',
    title: '高端商务PPT模板合集 - 200套精选',
    description: '200套精心设计的商务PPT模板，涵盖汇报、提案、路演等多种场景，支持一键换色。',
    category: '办公资源',
    categorySlug: 'office',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20business%20presentation%20slides%20design%20with%20clean%20modern%20layout%20on%20laptop%20screen%2C%20warm%20office%20setting%2C%20minimal%20style%2C%20soft%20neutral%20background%2C%20editorial%20photography%20with%20elegant%20composition&width=800&height=600&seq=resource-office-01&orientation=landscape',
    tags: ['PPT模板', '商务', '演示文稿', '汇报'],
    downloadCount: 78230,
    rating: 4.9,
    date: '2026-07-25',
    content: '',
    featured: true,
  },
  {
    id: 'r003',
    title: '2025最新UI设计规范与组件库合集',
    description: '包含iOS、Android、Web端最新设计规范文档，以及Figma、Sketch组件库源文件。',
    category: '设计素材',
    categorySlug: 'design',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20UI%20design%20system%20kit%20displayed%20on%20monitor%20with%20color%20palette%20and%20components%2C%20creative%20studio%20setting%2C%20warm%20lighting%2C%20minimal%20aesthetic%2C%20professional%20editorial%20photography%20with%20clean%20composition&width=800&height=600&seq=resource-design-01&orientation=landscape',
    tags: ['UI设计', '组件库', 'Figma', '设计规范'],
    downloadCount: 35670,
    rating: 4.7,
    date: '2026-07-22',
    content: '',
    featured: true,
  },
  {
    id: 'r004',
    title: '程序员必备效率工具包 - 30款实用软件',
    description: '精选30款提升开发效率的实用工具，包含代码编辑器插件、API调试、数据库管理等。',
    category: '工具软件',
    categorySlug: 'tools',
    coverImage: 'https://readdy.ai/api/search-image?query=Developer%20workspace%20with%20code%20editor%20and%20productivity%20tools%20on%20screen%2C%20modern%20minimal%20desk%20setup%2C%20warm%20ambient%20lighting%2C%20clean%20aesthetic%2C%20professional%20editorial%20photography%20with%20organized%20layout&width=800&height=600&seq=resource-tools-01&orientation=landscape',
    tags: ['效率工具', '开发工具', '插件', '软件合集'],
    downloadCount: 28940,
    rating: 4.6,
    date: '2026-07-20',
    content: '',
    featured: true,
  },
  {
    id: 'r005',
    title: '短视频创作全流程素材包 - 1000+素材',
    description: '1000+精选短视频素材，包含转场特效、背景音乐、字幕模板、封面模板等全流程资源。',
    category: '视频素材',
    categorySlug: 'video',
    coverImage: 'https://readdy.ai/api/search-image?query=Video%20editing%20workspace%20with%20timeline%20and%20creative%20assets%20on%20monitor%2C%20modern%20studio%20setup%2C%20warm%20cinematic%20lighting%2C%20minimal%20aesthetic%2C%20professional%20editorial%20photography%20with%20dynamic%20composition&width=800&height=600&seq=resource-video-01&orientation=landscape',
    tags: ['短视频', '视频素材', '转场', '音效'],
    downloadCount: 52100,
    rating: 4.8,
    date: '2026-07-18',
    content: '',
    featured: true,
  },
  {
    id: 'r006',
    title: 'React全栈项目实战源码合集 - 20个项目',
    description: '20个完整的React全栈项目源码，涵盖电商、社交、管理后台等实际业务场景，附带详细文档。',
    category: '源码资源',
    categorySlug: 'code',
    coverImage: 'https://readdy.ai/api/search-image?query=Code%20editor%20with%20React%20source%20code%20and%20project%20structure%20on%20screen%2C%20modern%20developer%20workspace%2C%20warm%20ambient%20lighting%2C%20minimal%20aesthetic%2C%20professional%20editorial%20photography%20with%20clean%20composition&width=800&height=600&seq=resource-code-01&orientation=landscape',
    tags: ['React', '源码', '全栈', '项目实战'],
    downloadCount: 19340,
    rating: 4.9,
    date: '2026-07-15',
    content: '',
    featured: false,
  },
  {
    id: 'r007',
    title: '大学英语四六级全套备考资料',
    description: '包含历年真题、听力音频、词汇手册、写作模板、翻译练习等全方位备考资料。',
    category: '学习资源',
    categorySlug: 'study',
    coverImage: 'https://readdy.ai/api/search-image?query=English%20exam%20study%20materials%20with%20textbooks%20and%20headphones%20on%20desk%2C%20warm%20natural%20light%2C%20minimal%20aesthetic%2C%20educational%20theme%2C%20soft%20cream%20background%2C%20editorial%20photography%20with%20organized%20composition&width=800&height=600&seq=resource-study-02&orientation=landscape',
    tags: ['英语', '四六级', '真题', '听力'],
    downloadCount: 67200,
    rating: 4.7,
    date: '2026-07-12',
    content: '',
    featured: false,
  },
  {
    id: 'r008',
    title: 'Excel数据分析模板大全 - 100个模板',
    description: '100个实用的Excel数据分析模板，包含财务分析、销售报表、项目管理、库存管理等场景。',
    category: '办公资源',
    categorySlug: 'office',
    coverImage: 'https://readdy.ai/api/search-image?query=Excel%20spreadsheet%20with%20data%20charts%20and%20analysis%20on%20desktop%20screen%2C%20modern%20office%20setting%2C%20warm%20lighting%2C%20minimal%20aesthetic%2C%20professional%20editorial%20photography%20with%20clean%20layout&width=800&height=600&seq=resource-office-02&orientation=landscape',
    tags: ['Excel', '数据分析', '模板', '报表'],
    downloadCount: 45100,
    rating: 4.6,
    date: '2026-07-10',
    content: '',
    featured: false,
  },
  {
    id: 'r009',
    title: '品牌VI设计全套素材 - 500+款Logo模板',
    description: '500+款商业Logo模板、VI手册、名片设计、品牌色板等全套品牌设计素材，可直接商用。',
    category: '设计素材',
    categorySlug: 'design',
    coverImage: 'https://readdy.ai/api/search-image?query=Brand%20identity%20design%20collection%20with%20logo%20samples%20and%20color%20palette%20on%20creative%20desk%2C%20modern%20studio%2C%20warm%20lighting%2C%20minimal%20aesthetic%2C%20professional%20editorial%20photography%20with%20artistic%20composition&width=800&height=600&seq=resource-design-02&orientation=landscape',
    tags: ['品牌设计', 'Logo', 'VI手册', '商用'],
    downloadCount: 38900,
    rating: 4.8,
    date: '2026-07-08',
    content: '',
    featured: false,
  },
  {
    id: 'r010',
    title: 'Windows系统优化工具箱 - 50款实用软件',
    description: '50款精心挑选的Windows系统优化工具，包含清理加速、安全防护、文件管理等实用功能。',
    category: '工具软件',
    categorySlug: 'tools',
    coverImage: 'https://readdy.ai/api/search-image?query=Computer%20system%20optimization%20software%20interface%20display%20on%20monitor%2C%20modern%20tech%20setup%2C%20warm%20ambient%20lighting%2C%20minimal%20aesthetic%2C%20professional%20editorial%20photography%20with%20clean%20composition&width=800&height=600&seq=resource-tools-02&orientation=landscape',
    tags: ['系统优化', 'Windows', '工具箱', '清理'],
    downloadCount: 33400,
    rating: 4.5,
    date: '2026-07-05',
    content: '',
    featured: false,
  },
  {
    id: 'r011',
    title: 'Premiere Pro专业视频转场插件包',
    description: '200+款专业级Pr转场预设，包含无缝转场、故障特效、光效转场等多种风格，即装即用。',
    category: '视频素材',
    categorySlug: 'video',
    coverImage: 'https://readdy.ai/api/search-image?query=Video%20editing%20software%20with%20transition%20effects%20panel%20on%20screen%2C%20creative%20studio%2C%20warm%20cinematic%20lighting%2C%20minimal%20aesthetic%2C%20professional%20editorial%20photography%20with%20dynamic%20composition&width=800&height=600&seq=resource-video-02&orientation=landscape',
    tags: ['Pr插件', '转场', '视频特效', '预设'],
    downloadCount: 27800,
    rating: 4.7,
    date: '2026-07-03',
    content: '',
    featured: false,
  },
  {
    id: 'r012',
    title: 'Vue3+TypeScript企业级后台管理系统源码',
    description: '基于Vue3、TypeScript、Element Plus构建的完整企业级后台管理系统源码，含权限管理、多标签页等功能。',
    category: '源码资源',
    categorySlug: 'code',
    coverImage: 'https://readdy.ai/api/search-image?query=Admin%20dashboard%20interface%20with%20charts%20and%20data%20tables%20on%20screen%2C%20modern%20tech%20workspace%2C%20warm%20ambient%20lighting%2C%20minimal%20aesthetic%2C%20professional%20editorial%20photography%20with%20clean%20layout&width=800&height=600&seq=resource-code-02&orientation=landscape',
    tags: ['Vue3', 'TypeScript', '后台管理', '企业级'],
    downloadCount: 16200,
    rating: 4.9,
    date: '2026-07-01',
    content: '',
    featured: false,
  },
];

export const featuredArticles = resources.filter((r) => r.featured);

export const aboutInfo = {
  brandStory: `给力资源库成立于2020年，由一群热爱分享的互联网从业者创建。我们深知在学习和工作过程中，找到高质量、靠谱的资源是多么重要。因此，我们致力于打造一个真正优质、全面、免费的一站式资源获取平台。

经过多年的积累与发展，给力资源库已拥有超过50,000份精品资源，涵盖学习考试、办公效率、设计创意、软件开发等多个领域。我们坚持每日更新，确保每一位用户都能获取到最新、最实用的资源。

我们的愿景是：让每个人都能轻松获取优质资源，让学习与工作更高效、更快乐。`,
  reputation: [
    { text: '资源覆盖面广，从学习到办公再到设计，想要的资源这里基本都能找到，而且质量确实高。', author: '王同学', role: '大学生', rating: 5 },
    { text: '作为职场新人，PPT模板和Excel模板帮了我大忙，工作效率提升了不少。关键还免费，太良心了！', author: '李先生', role: '产品经理', rating: 5 },
    { text: '设计师的宝藏网站！素材质量很高，风格也很新，比很多付费网站都好用。', author: '张设计师', role: 'UI设计师', rating: 5 },
    { text: '视频素材区的转场和特效插件太实用了，省了好多时间。更新速度也很快，一直有新的好东西。', author: '刘博主', role: '视频创作者', rating: 5 },
    { text: '程序员的资源库也很给力，源码项目完整、文档详细，对学习提升很有帮助。', author: '赵工程师', role: '全栈开发', rating: 5 },
    { text: '四六级备考资料很全，还有考研资料，对我们学生来说简直是及时雨，推荐给所有同学了！', author: '陈同学', role: '大三学生', rating: 5 },
  ],
  contact: {
    email: 'contact@geiliziyuan.com',
    wechat: 'GeiliZiyuan',
    qq: '88886666',
    weibo: '@给力资源库',
    address: '北京市海淀区中关村科技园区',
    workHours: '周一至周日 9:00 - 21:00',
  },
};

export const faqs = [
  { question: '给力资源库的资源是否全部免费？', answer: '是的，给力资源库的所有资源均免费提供下载。我们坚持免费分享的理念，让每一位用户都能无障碍地获取优质资源。部分资源可能需要注册账号后下载。' },
  { question: '资源多久更新一次？', answer: '我们坚持每日更新，每周新增资源不少于200份。重大节假日或热点事件期间，还会推出专题资源合集，让您第一时间获取最新内容。' },
  { question: '下载的资源可以商用吗？', answer: '大部分资源的授权协议支持个人学习和商业使用，但不同资源的授权条款可能有所不同。建议下载前查看资源详情页的具体授权说明，确保合规使用。' },
  { question: '如何快速找到我需要的资源？', answer: '您可以通过首页的搜索框直接搜索关键词，也可以进入对应的分类页面按类别浏览。每个分类下还有标签筛选功能，帮助您精准定位所需资源。' },
  { question: '资源下载速度慢怎么办？', answer: '我们为热门资源提供了多条下载线路和网盘分流链接。如果遇到下载速度慢的问题，可以尝试切换其他下载线路，或选择非高峰时段下载。' },
  { question: '如何投稿或推荐资源？', answer: '欢迎通过关于我们页面的联系方式与我们取得联系。我们非常欢迎优质资源投稿，通过审核的资源将标注投稿者信息并上架分享。' },
];